import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import ApolloClient from "apollo-boost";
import { ApolloProvider } from "react-apollo";
//const client = new ApolloClient({ uri: "https://api.rizee.in/graphql" });
// const client = new ApolloClient({ uri: "http://localhost:3008/graphql" });
//const client = new ApolloClient({ uri: "http://gdev.mylearningplus.in/graphql" });
// const client = new ApolloClient({ uri: "https://capi.rizee.in/graphql" });
const client = new ApolloClient({ uri: process.env.REACT_APP_API_URL });

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
